export class MyAddress {
    id?: number;
    user_id?: number;
    title?: string;
    formatted_address: string;
    longitude: string;
    latitude: string;
}